/**
 * 思维链编辑器路由
 */
import { PAGE_LEVEL } from '@/constants';
import { isElectron } from '@/utils/electron';

export default {
  path: '/aiChat/thoughtChain',
  name: 'thoughtChainEditor',
  component: () =>
    import(
      /* webpackChunkName: 'thought-chain-editor' */ '@/pages/aiAssistant/chatMode/researchBrainManage/thoughtChainEditor.vue'
    ),
  meta: {
    localeModules: ['aiChat', 'aiChatConstants', 'cloudDocument', 'openClaw', 'report', 'summary'],
    name: 'routers.ai_chat_thought_chain',
    pageLevel: PAGE_LEVEL.SECOND,
    parent: '/aiChat/index',
    componentName: 'ThoughtChainEditor',
    hiddenNav: true,
    single: true,
    hideOuterBreadcrumb: isElectron,
    electronSingle: true,
    keepAlive: false,
    requireAuth: false
  }
};
